module.exports = __webpack_public_path__ + "img/thank-you-bg.dc939be0.png";